import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStatisticians = async (orgId) =>
  (await axiosInstance.get(`v1/orgs/${orgId}/stats/statisticians`))?.data

export default getStatisticians
